(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["personalization-step-2-form"] && !Shopify.designMode) return;
  try {
    function bindDedicationTextarea(textarea) {
    // why: this block runs once per page load, but a card switch on the product page inserts a
    // new wizard without one (assets/product-format-switch.mjs) - its textarea is bound on
    // product-format:changed, and one that is bound already keeps its single set of listeners.
    if (textarea.dataset.dedicationBound === 'true') return;
    textarea.dataset.dedicationBound = 'true';

    var minHeight = 220;
    var mainCharacterTokenRegex = /\{\{\s*main_character\s*\}\}/g;
    var counter = textarea.parentNode.querySelector('.personalization-step-dedication-counter');
    var counterTemplate = counter ? counter.getAttribute('data-counter-template') || '' : '';
    var emojiHint = textarea.closest('.personalization-choice-card-body')?.querySelector('[data-dedication-emoji-hint]');
    var emojiRemovedHintMessage = emojiHint ? emojiHint.getAttribute('data-hint-message') || '' : '';
    var emojiHintTimeout = null;
    var dedicationTemplate = textarea.getAttribute('data-dedication-template') || '';
    var lastAutoFilledValue = '';
    var hasUserEditedDedication = false;
    // The drawer (which contains both this textarea and the name input) may
    // have been moved to <body> by the vendor modal component; scope lookups
    // to it so multiple wizard instances on one page don't cross-talk.
    function getScopeRoot() {
      return textarea.closest('modal-drawer') || document;
    }

    function getMainCharacterName() {
      // The config-driven renderer names the input __main_character (after the
      // bookpipe option key); pre-cutover drafts used __main-character-name.
      var input = getScopeRoot().querySelector('input[name="__main_character"], input[name="__main-character-name"]');
      var inputValue = input ? String(input.value || '').trim() : '';
      if (inputValue) return inputValue;

      try {
        var drawer = textarea.closest('modal-drawer');
        var productId = drawer ? String(drawer.id || '').replace('personalize-modal-', '') : null;
        if (!productId) return '';

        // personalization.js owns the (versioned) draft key — without the
        // shared builder there is no valid key to read from.
        var draftStorage = window.PersonalizationDraftStorage;
        if (!draftStorage) return '';

        var raw = window.localStorage.getItem(draftStorage.key(productId));
        if (!raw) return '';

        var data = JSON.parse(raw);
        var value = data && (data['__main_character'] || data['__main-character-name']);
        return value ? String(value).trim() : '';
      } catch (e) {
        return '';
      }
    }

    function buildDedicationValue() {
      return dedicationTemplate.replace(mainCharacterTokenRegex, getMainCharacterName());
    }

    function syncDedicationTemplate(force) {
      var nextValue = buildDedicationValue();
      var currentValue = textarea.value || '';
      var shouldSync = force || !hasUserEditedDedication || currentValue === lastAutoFilledValue;

      textarea.placeholder = nextValue;

      if (!shouldSync) return;

      textarea.value = nextValue;
      lastAutoFilledValue = nextValue;
    }

    function showEmojiHint() {
      if (!emojiHint || !emojiRemovedHintMessage) return;
      emojiHint.textContent = emojiRemovedHintMessage;
      emojiHint.classList.remove('hidden');
      emojiHint.removeAttribute('hidden');

      if (emojiHintTimeout) {
        window.clearTimeout(emojiHintTimeout);
      }

      emojiHintTimeout = window.setTimeout(function () {
        emojiHint.classList.add('hidden');
        emojiHint.setAttribute('hidden', '');
      }, 2500);
    }

    function sanitizeTextareaValue() {
      var sanitizer = window.PersonalizationFieldSanitizer;
      if (!sanitizer || typeof sanitizer.sanitizeFieldValue !== 'function') return false;
      return sanitizer.sanitizeFieldValue(textarea).changed;
    }

    function ensureMinHeight() {
      if (minHeight) return;
      var h = textarea.offsetHeight || textarea.clientHeight || 0;
      if (h > 0) minHeight = h;
    }

    function resize() {
      ensureMinHeight();
      textarea.style.height = 'auto';

      var style = window.getComputedStyle(textarea);
      var lineHeight = parseFloat(style.lineHeight);
      var currentScrollHeight = textarea.scrollHeight;

      if (minHeight && currentScrollHeight < minHeight) {
        currentScrollHeight = minHeight;
      }

      if (lineHeight && !isNaN(lineHeight)) {
        var newHeight = (currentScrollHeight / lineHeight) + 'lh';
        textarea.style.height = newHeight;
      } else {
        textarea.style.height = currentScrollHeight + 'px';
      }
    }

    function scheduleResize() {
      window.requestAnimationFrame(function () {
        resize();
        window.requestAnimationFrame(resize);
      });
    }

    function updateCounter() {
      if (!counter) return;
      var currentLength = textarea.value.length;
      var maxLength = textarea.getAttribute('maxlength') || 250;
      var remaining = maxLength - currentLength;
      counter.textContent = counterTemplate.replace('__COUNT__', remaining);
      counter.classList.toggle('is-limit-reached', remaining <= 0);
    }

    sanitizeTextareaValue();
    syncDedicationTemplate(true);
    scheduleResize();
    updateCounter();

    // Typing a dedication counts as opting in: select "Ja" so fee and
    // validation follow. Only for trusted events — the wizard's restore
    // logic dispatches synthetic input events when re-filling saved
    // values, and those must not flip the customer's choice.
    function selectYesOnUserInput(event) {
      if (!event.isTrusted) return;
      var card = textarea.closest('.personalization-choice-card');
      var yesRadio = card ? card.querySelector('input[name="__add-dedication"][value="true"]') : null;
      if (!yesRadio || yesRadio.checked) return;
      yesRadio.checked = true;
      yesRadio.dispatchEvent(new Event('input', { bubbles: true }));
      yesRadio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    textarea.addEventListener('input', function (event) {
      hasUserEditedDedication = (textarea.value || '') !== lastAutoFilledValue;
      selectYesOnUserInput(event);
      if (sanitizeTextareaValue()) {
        showEmojiHint();
      }
      scheduleResize();
      updateCounter();
    });

    // maxlength schluckt alles über dem Limit, ohne dass ein 'input'-Event
    // feuert — geblockte Eingaben werden deshalb vor dem Einfügen erkannt.
    function wouldExceedLimit(insertedLength) {
      var maxLength = parseInt(textarea.getAttribute('maxlength'), 10) || 250;
      var selectionLength = (textarea.selectionEnd || 0) - (textarea.selectionStart || 0);
      return textarea.value.length - selectionLength + insertedLength > maxLength;
    }

    function triggerLimitShake() {
      if (!counter) return;
      counter.classList.remove('personalization-step-dedication-counter--shake');
      void counter.offsetWidth;
      counter.classList.add('personalization-step-dedication-counter--shake');
    }

    textarea.addEventListener('keydown', function (event) {
      if (!event.isTrusted) return;
      var isPrintable = event.key && event.key.length === 1;
      if (!isPrintable && event.key !== 'Enter') return;
      // Cmd/Ctrl-Shortcuts tippen nichts; AltGr (= ctrl+alt) auf deutschen
      // Tastaturen schon, deshalb nur ohne gedrücktes Alt aussortieren.
      if ((event.ctrlKey || event.metaKey) && !event.altKey) return;
      if (wouldExceedLimit(1)) triggerLimitShake();
    });

    textarea.addEventListener('beforeinput', function (event) {
      if (!event.isTrusted) return;
      if (!event.inputType || event.inputType.indexOf('insert') !== 0) return;
      var inserted = event.data || '';
      if (!inserted && event.dataTransfer) {
        inserted = event.dataTransfer.getData('text/plain') || '';
      }
      if (wouldExceedLimit(inserted.length || 1)) triggerLimitShake();
    });

    textarea.addEventListener('paste', function (event) {
      if (!event.isTrusted || !event.clipboardData) return;
      var pasted = event.clipboardData.getData('text/plain') || '';
      if (pasted && wouldExceedLimit(pasted.length)) triggerLimitShake();
    });

    document.addEventListener('input', function (event) {
      var name = event.target ? event.target.name : '';
      if (name !== '__main_character' && name !== '__main-character-name') return;

      syncDedicationTemplate(false);
      sanitizeTextareaValue();
      scheduleResize();
      updateCounter();
    });

    var form = textarea.closest('.personalization-step-form');
    if (form && window.MutationObserver) {
      var observer = new MutationObserver(function () {
        if (form.hasAttribute('hidden') || form.classList.contains('hidden')) return;
        syncDedicationTemplate(false);
        scheduleResize();
      });
      observer.observe(form, { attributes: true, attributeFilter: ['hidden', 'class'] });
    }

  }

  function initDedicationTextareas() {
    document.querySelectorAll('textarea.personalization-step-dedication').forEach(bindDedicationTextarea);
  }

  initDedicationTextareas();
  document.addEventListener('product-format:changed', initDedicationTextareas);
  } catch(e) { console.error(e); }
})();

})();
